
 const PNMCalc = ([jan, feb, mar, apr, ma, jun, jul, aug, sep, oct, nov, dec]) => {

    const surcharge = 7.11


    // This is the black hills stuff. This calculates how much they are going to pay there...

    // cost per kWh
    const wTier1 = 0.0779432
    const wTier2 = 0.1070240
    const wTier3 = 0.1217077

    const sTier1 = 0.0779432
    const sTier2 = 0.1240339
    const sTier3 = 0.1495326

    // functions to get bill amounts for each month

    const winter = (num) => {
      let tier1 = 450 * sTier1
      let tier2 = tier1 + 450 * sTier2
      let fuelCost = (num * .86) * .0153596
      let renewRider = num * .0066138

      if
        (num >= 900) {
        return ((num - 900) * wTier3 + tier2 + fuelCost + renewRider + surcharge) * 1.134215
      } else if
        (num >= 450 && num < 900) {
        return ((num - 450) * wTier2 + tier1 + fuelCost + renewRider + surcharge) * 1.134215
      } else {
        return (num * wTier1 + fuelCost + renewRider + surcharge) * 1.134215
      }
    }

    const summer = (num) => {
      let tier1 = 450 * sTier1
      let tier2 = tier1 + 450 * sTier2
      let fuelCost = (num * .86) * .0153596
      let renewRider = num * .0066138

      if
        (num >= 900) {
        return ((num - 900) * sTier3 + tier2 + fuelCost + renewRider + surcharge) * 1.134215
      } else if
        (num >= 450 && num < 900) {
        return ((num - 450) * sTier2 + tier1 + fuelCost + renewRider + surcharge) * 1.134215
      } else {
        return (num * sTier1 + fuelCost + renewRider + surcharge) * 1.134215
      }
    }

    let january = winter(jan).toFixed(2)
    let february = winter(feb).toFixed(2)
    let march = winter(mar).toFixed(2)
    let april = winter(apr).toFixed(2)
    let may = winter(ma).toFixed(2)
    let june = summer(jun).toFixed(2)
    let july = summer(jul).toFixed(2)
    let august = summer(aug).toFixed(2)
    let september = winter(sep).toFixed(2)
    let october = winter(oct).toFixed(2)
    let november = winter(nov).toFixed(2)
    let december = winter(dec).toFixed(2)

    let bills = [+january, +february, +march, +april, +may, +june, +july, +august, +september, +october, +november, +december]
    let usage = [+jan, +feb, +mar, +apr, +ma, +jun, +jul, +aug, +sep, +oct, +nov, +dec]

    const average = (arr) => arr.reduce((a, b) => a + b) / arr.length
    const total = (arr) => arr.reduce((a, b) => a + b)

    let avgBill = average(bills).toFixed(2)
    let avgUsage = Math.floor(average(usage))
    let totalUsage = Math.floor(total(usage))
    let annualBill = total(bills).toFixed(2)

    return [bills, +avgBill, totalUsage, +annualBill, avgUsage]
  }
export default PNMCalc